import React from 'react';

import './SubscriptionCell.scss';
import { Button, Typography } from '@mui/material';

import checkIcon from '../../../../common/assets/icons/check_icon.svg';
import { AvailableAppSubscription } from '../../../types/AvailableAppSubscription';
import { SubscriptionType } from '../../../types/SubscriptionType';

type SubscriptionCellTypes = {
  subscription: AvailableAppSubscription;
  activeSubscriptionType: SubscriptionType;
  onPressSubscribe: (
    subscriptionPlan: AvailableAppSubscription
  ) => Promise<void>;
};

const SubscriptionCell: React.FC<SubscriptionCellTypes> = (props) => {
  const planIsActive = props.subscription.type === props.activeSubscriptionType;

  return (
    <div className={'subscription-cell-container'}>
      <Typography fontSize={20} fontWeight={600}>
        {props.subscription.name}
      </Typography>
      <div>
        <div className={'info-line'}>
          <p className={'info-line-text'}>Mobile App</p>
          <p
            className={
              props.subscription.mobileAccess
                ? 'info-line-text green-line'
                : 'info-line-text'
            }
          >
            {props.subscription.mobileAccess ? 'Yes' : 'No'}
          </p>
        </div>
        <div className={'info-line'}>
          <p className={'info-line-text'}>Web App</p>
          <p
            className={
              props.subscription.webAccess
                ? 'info-line-text green-line'
                : 'info-line-text'
            }
          >
            {props.subscription.webAccess ? 'Yes' : 'No'}
          </p>
        </div>
        <div className={'info-line'}>
          <p className={'info-line-text'}>Op Note History</p>
          <p className={'info-line-text'}>{props.subscription.billingSheets}</p>
        </div>
        <div className={'info-line'}>
          <p className={'info-line-text'}>EHR Integrations</p>
          <p
            className={
              props.subscription.discountedRetrospectiveAudit
                ? 'info-line-text green-line'
                : 'info-line-text'
            }
          >
            {props.subscription.discountedRetrospectiveAudit ? 'Yes' : 'No'}
          </p>
        </div>
        {props.subscription.monthlyCost > 0 && (
          <div className={'price-line'}>
            <Typography fontSize={20} fontWeight={600}>
              ${props.subscription.monthlyCost}
            </Typography>
            <Typography
              fontSize={16}
              fontWeight={500}
              style={{ marginLeft: 6 }}
            >
              monthly
            </Typography>
          </div>
        )}
        {props.subscription.monthlyCost === 0 && (
          <div className={'price-line'}>
            <Typography fontSize={18} fontWeight={600}>
              Price on request
            </Typography>
          </div>
        )}
      </div>
      {props.subscription.monthlyCost > 0 && (
        <Button
          color='primary'
          variant='contained'
          disableElevation
          disabled={planIsActive}
          onClick={() => props.onPressSubscribe(props.subscription)}
          className={
            planIsActive ? 'subscribe-button subscribed' : 'subscribe-button'
          }
        >
          {planIsActive && (
            <div className='check-mark'>
              <img src={checkIcon} alt='CheckMark' />
            </div>
          )}
          <Typography fontSize={18} color='white' fontWeight={500}>
            {planIsActive ? 'Subscribed' : 'Subscribe'}
          </Typography>
        </Button>
      )}
      {props.subscription.monthlyCost === 0 && (
        <Button
          color='primary'
          variant='contained'
          disableElevation
          disabled={planIsActive}
          onClick={() =>
            window.open('https://www.galeai.co/contact-us', '_blank')
          }
          className={
            planIsActive ? 'subscribe-button subscribed' : 'subscribe-button'
          }
        >
          {planIsActive && (
            <div className='check-mark'>
              <img src={checkIcon} alt='CheckMark' />
            </div>
          )}
          <Typography fontSize={18} color='white' fontWeight={500}>
            {planIsActive ? 'Subscribed' : 'Contact sales'}
          </Typography>
        </Button>
      )}
    </div>
  );
};

export default SubscriptionCell;
